import React, { useState, useRef, useEffect } from 'react';
import './Footer.css';

const Footer = () => {
  const [language, setLanguage] = useState('ru');
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { value: 'ru', label: 'Русский' }
  ];

  const selectedLanguage = languages.find(lang => lang.value === language) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleSelect = (lang) => {
    setLanguage(lang.value);
    setIsOpen(false);
  };

  return (
    <footer className="app-footer">
      <div className="footer-content">
          <div className="footer-section">
            <h4>Язык</h4>
            <div className="language-select-wrapper" ref={dropdownRef}>
              <button
                type="button"
                className="language-select-button"
                onClick={() => setIsOpen(!isOpen)}
              >
                {selectedLanguage.label}
              </button>
              {isOpen && (
                <div className="language-dropdown">
                  {languages.map((lang) => (
                    <div
                      key={lang.value}
                      className={`language-option ${language === lang.value ? 'selected' : ''}`}
                      onClick={() => handleSelect(lang)}
                    >
                      {lang.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        <div className="footer-section">
          <h4>О нас</h4>
          <p>RoseLearn.me - платформа для онлайн обучения с интерактивными уроками и видеосвязью.</p>
        </div>
        <div className="footer-section">
          <h4>Контакты</h4>
          <p>
            <a href="mailto:support@roselearn.me">support@roselearn.me</a>
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} RoseLearn.me. Все права защищены.</p>
      </div>
    </footer>
  );
};

export default Footer;

